import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查看当事人")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_page = _resolveComponent("page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.table,
        stripe: "",
        "empty-text": "没有记录",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            type: "index",
            label: "序号",
            width: "50"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "caseName",
            label: "文书标题"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "caseReason",
            label: "案由"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "caseNo",
            label: "案号"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "amount",
            label: "案件金额"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.amount?scope.row.amount+'元':'-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "judgeDate",
            label: "裁判日期"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.toDate(scope.row.judgeDate,'YYYY-MM-DD')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "partyList",
            label: "当事人信息"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_popover, {
                placement: "bottom",
                width: 600,
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "text" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_table, {
                    data: scope.row.partyList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        align: "center",
                        type: "index",
                        label: "序号",
                        width: "50"
                      }),
                      _createVNode(_component_el_table_column, {
                        align: "center",
                        prop: "name",
                        label: "当事人名称"
                      }),
                      _createVNode(_component_el_table_column, {
                        align: "center",
                        prop: "roleType",
                        label: "案件角色"
                      })
                    ]),
                    _: 2
                  }, 1032, ["data"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.ckInfo(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_page, {
      currentPage: _ctx.pageIndex,
      pageSize: _ctx.pageSize,
      pages: _ctx.pageCount,
      onChangePage: _ctx.changePage
    }, null, 8, ["currentPage", "pageSize", "pages", "onChangePage"])
  ], 64))
}